var newsletterForm = {
	bindings: {
		terms: '@',
		success: '@'
	},
	controller: function NewsletterCtrl ($element, $scope, $window, $timeout, DataService) {
		var ctrl = this;
		// console.log(ctrl.terms);

		function onInit(){

			ctrl.formData = {
				subscription : "studerende"
			};
			ctrl.submitSuccess = false;
		}

		function link(){
			$element[0].setAttribute("terms", "");
			$element[0].setAttribute("success", "");
		}

		function reset () {
			ctrl.submitSuccess = false;
			ctrl.formData = {
				subscription : "studerende"
			};
			$scope.newsletterForm.$setPristine();
			$scope.newsletterForm.$setUntouched();
			
		}

		function onSignupComplete(response) {
			ctrl.submitSuccess = true;
			ctrl.submitting = false;
			$timeout(reset, 5000);
		}

		function onSignupError(error) {
			ctrl.submitting = false;
			ctrl.submitSuccess = true;
			// $window.alert('An error occurred during signup');
		}

		this.submitForm = function submitForm (isValid) {
			if (isValid) {
				ctrl.submitting = true;
				DataService.newsletterSignup(ctrl.formData.email, ctrl.formData.subscription).then(onSignupComplete, onSignupError);
			}
		}	

		ctrl.$onInit = onInit;
		ctrl.$postLink = link;
	},
	templateUrl: themeUrl + '/assets/static/html/newsletter.component.html?v=' + window.assetVersion
};